import { AppBar, BottomNavigation, BottomNavigationAction, Box, Paper, useTheme } from "@mui/material"
import { useNavigate, useLocation } from "react-router-dom"
import Navbar from "./Navbar"
import { navbarHeight } from "../theme"

const MobileNavigation = ({ menuItems, children }) => {

    const navigate = useNavigate()

    const handleSelect = path => { navigate(path) }

    const location = useLocation()

    const isCurrentPage = (path) => location.pathname.includes(path)

    const theme = useTheme()

    return <>

        <Navbar AppBarComponent={AppBar} />

        <Paper sx={{
            mt: `${navbarHeight + 5}px`,
            height: 'calc(100vh - 125px)',
            overflow: 'auto',
        }}>
            {children}
        </Paper>
        <Box sx={{ height: 56 }} />
        <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 2 }} elevation={3} >
            <BottomNavigation showLabels >
                {menuItems.map((route, index) => <BottomNavigationAction
                    key={index}
                    label={route.name}
                    icon={<route.icon
                        sx={{ color: isCurrentPage(route.path) ? theme.palette.primary.main : theme.palette.secondary.main }}
                    />}
                    onClick={() => handleSelect(route.path)}
                />)}
            </BottomNavigation>
        </Paper>
    </>
}

export default MobileNavigation